export default {
  buttons: {
    home: 'Startseite',
    close: 'schließen',
    language: 'Sprache wechseln',
  },
  home: {
    visit: 'Besuch',
    team: 'Team',
    contact: 'Kontakt',
    ausstellung: 'Ausstellung',
    journal: 'Journal',
    symposium: 'Symposium',
    unconference: 'Unconference',
    imprint: 'Impressum',
    subtitle: '(Netz)Kunst und Kybernetik',
  },
  archive: {
    title: 'Archiv',
    about: 'Über das Archiv',
    filter: 'nach Schlagwort filtern',
    tags: {
      reset: 'Schlagwörter zurücksetzen',
      result: 'Eintrag',
      results: 'Einträge',
    },
    loadMore: 'Mehr Einträge laden',
    search: 'Suchen',
  },
  item: {
    abstract: 'Abstrakt',
    accessDate: 'Zugriffsdatum',
    archive: 'Archiv',
    authors: 'Autor*innen',
    catalog: 'Katalog',
    date: 'Datum',
    dateAdded: 'Hinzufügungsdatum',
    entry: 'Eintrag',
    showRelatedEntries: 'verwandte Einträge anzeigen',
    hideRelatedEntries: 'verwandte Einträge ausblenden',
    language: 'Sprache',
    pages: 'Seitenzahl',
    publisher: 'Verlag',
    runningTime: 'Laufzeit',
    title: 'Titel',
    type: 'Typ',
    back: 'zurück',
  },
  unconference: {
    about: 'Über die Unconference',
  },
  symposium: {
    about: 'Über das online Symposium',
  },
  ausstellung: {
    about: 'Über die Ausstellung',
  },
  datepicker: {
    all: 'alle Tage',
  },
  event: {
    enterOnlineExhibition: 'Online-Ausstellung',
    booking: 'Termin vereinbaren',
    register: 'Anmeldung',
    watchOnYoutube: 'Auf YouTube ansehen',
  },
  journal: {
    about: 'Über das Journal',
    readFull: 'Den ganzen Beitrag lesen',
  },
  tags: {
    live: 'live',
    ongoing: 'aktuell',
    new: 'neu',
    ausstellung: 'Ausstellung',
    exhibition: 'Ausstellung',
    symposium: 'Symposium',
    journal: 'Journal',
    unconference: 'unconference',
    person: 'Person',
    kybernetik: 'Kybernetik',
    ddr: 'DDR',
    'haus der statistik': 'Haus der Statistik',
    'kunst am bau': 'Kunst am Bau',
    netzkunst: 'Netzkunst',
    datenverarbeitung: 'Datenverarbeitung',
    kunst: 'Kunst',
    datenvisualisierung: 'Datenvisualisierung',
    architektur: 'Architektur',
    utopie: 'Utopie',
    überwachung: 'Überwachung',
    sozialismus: 'Sozialismus',
    magie: 'Magie',
  },
};
